import resizeCanvas from '../util/resize-canvas';

class Highlighter {
  constructor() {
    this.highlighter = document.querySelector('.highlighter__canvas');
    this.ctx = this.highlighter.getContext('2d');
    this.container = document.querySelector('.highlighter');
    this.body = document.body;
    this.isDrawing = false;
    this.scale = window.devicePixelRatio;
    this.initCanvas();
    this.bind();
  }

  /**
   * Initialize and Bind Events
   */
  bind() {
    window.addEventListener('resize', this.onResize.bind(this));
    this.highlighter.addEventListener('mousedown', this.startDrawing.bind(this));
    this.highlighter.addEventListener('mousemove', this.draw.bind(this));
    this.highlighter.addEventListener('mouseup', this.stopDrawing.bind(this));
  }

  /**
   * Create and setup the canvas
   */
  initCanvas() {
    this.onResize();
  }

  /**
   * Window resize handler
   */
  onResize() {
    resizeCanvas(this.scale, this.container, this.highlighter, this.ctx);
  }

  /**
   * Sets up inital stroke path, adds drawing status class
   * @param {Object} e event object
   */
  startDrawing(e) {
    const pos = this.getPos(e);
    this.body.classList.add('highlighter--is-drawing');

    this.isDrawing = true;
    this.ctx.lineWidth = 60;
    this.ctx.lineJoin = this.ctx.lineCap = 'round';
    this.ctx.strokeStyle = '#ffefba';
    this.ctx.moveTo(pos.x, pos.y);
  }

  /**
   * Draws and connects the stroke to the initial starting coordinates
   * @param {Object} e event object
   */
  draw(e) {
    const pos = this.getPos(e);

    if (this.isDrawing) {
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
    }
  }

  /**
   * Ends stroke path, removes drawing status class
   */
  stopDrawing() {
    this.isDrawing = false;
    this.body.classList.remove('highlighter--is-drawing');
    this.ctx.beginPath();
  }

  /**
   * Returns x and y mouse coordinates
   * @param {Object} e event object
   */
  getPos(e) {
    let x = 0;
    let y = 0;

    x = e.layerX;
    y = e.layerY;

    return { x: x, y: y };
  }
}

export default Highlighter;
